import { NowContentProvider } from '../providers/nowContentProvider';
import { AsyncAction } from '../../base-classes/asyncAction';
import { mapParamsToObject } from '../../utilities/mapParamsToObject';
export const GET_NOW_CONTENT = new AsyncAction('GET_NOW_CONTENT');
export const GET_NOW_CONTENT_SETTINGS = new AsyncAction('GET_NOW_CONTENT_SETTINGS');
export const UPDATE_NOW_CONTENT_SETTINGS = new AsyncAction('UPDATE_NOW_CONTENT_SETTINGS');


export function getNowContent(...params) {

    let paramsObject = {
        baseUrl: undefined,
        authId: undefined,
        secret: undefined,
        appInstanceId:  undefined,
        latitude: undefined,
        longitude: undefined,
        stdParameters: undefined,
        verbose: undefined,
        refresh: undefined,
        timeoutMilliseconds: undefined
    };

    paramsObject = mapParamsToObject(params, paramsObject);


    return {
        type: GET_NOW_CONTENT.base,
        payload: getNowContentActionAsync(paramsObject)
    };
}

async function getNowContentActionAsync({ baseUrl, authId, secret, appInstanceId, latitude, longitude, stdParameters, verbose, refresh, timeoutMilliseconds }) {
    const options = timeoutMilliseconds ? { timeout: timeoutMilliseconds } : undefined;
    const op = new NowContentProvider(baseUrl, authId, secret, options);
    return await op.getNowContent(appInstanceId, latitude, longitude, stdParameters, verbose, refresh);
}

export function getNowContentSettings(...params) {
    let paramsObject = {
        baseUrl: undefined,
        authId: undefined,
        secret: undefined,
        appInstanceId: undefined,
        stdParameters: undefined,
        verbose: undefined,
        refresh: undefined,
        latitude: undefined,
        longitude: undefined
    };

    paramsObject = mapParamsToObject(params, paramsObject);

    return {
        type: GET_NOW_CONTENT_SETTINGS.base,
        payload: getNowContentSettingsAction(paramsObject)
    };
}

async function getNowContentSettingsAction({ baseUrl, authId, secret, appInstanceId, stdParameters, verbose, refresh, latitude, longitude }) {
    const op = new NowContentProvider(baseUrl, authId, secret);
    return await op.getNowContentSettings(appInstanceId, stdParameters, verbose, refresh, latitude, longitude);
}

export function updateNowContentSettings(...params) {
    let paramsObject = {
        baseUrl: undefined,
        authId: undefined,
        secret: undefined,
        appInstanceId: undefined,
        contentSettings: undefined,
        stdParameters: undefined,
        verbose: undefined
    };

    paramsObject = mapParamsToObject(params, paramsObject);

    return {
        type: UPDATE_NOW_CONTENT_SETTINGS.base,
        payload: updateNowContentSettingsAction(paramsObject)
    };
}

async function updateNowContentSettingsAction({ baseUrl, authId, secret, appInstanceId, contentSettings, stdParameters, verbose }) {
    const op = new NowContentProvider(baseUrl, authId, secret);
    return await op.updateNowContentSettings(appInstanceId, contentSettings, stdParameters, verbose);
}


export const SET_NOW_CONTENT_DATA = 'SET_NOW_CONTENT_DATA';

export function setNowContentData(nowContent) {
    return {
        type: SET_NOW_CONTENT_DATA,
        payload:nowContent
    };
}

